import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid, Skeleton, Stack, Typography } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import BaseImage from "../BaseImage";
import BaseButton from "../BaseButton";
import { openModal } from "../../store";
import usePermissions from "../../hooks/use-permissions";
import { ViewPermissions } from "../../constants";

const MyProfile = () => {
  const dispatch = useDispatch()
  const auth = useSelector(state => state.auth)
  const loadingAuth = useSelector(state => state.loadingAuth)
  const {myPermissions} = usePermissions();

  const handleClickEdit = () => {
    dispatch(
      openModal({
        currentModal: 'EDIT_PROFILE_MODAL',
    }))
  }

  const handleOrderKit = () => {
    dispatch(
      openModal({
        currentModal: 'OPEN_ORDER_KITS_MODAL',
    }))
  }
  
  return (
    <Box
      sx={{
        marginTop: '32px'
      }}
    >
      <Box>
        <Box
          sx={{
            mb: '24px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            variant="h2"
            color='primary.black'
          >
            My account
          </Typography>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleClickEdit}
          >
            <Typography
              variant="body"
              sx={{
                color: 'primary.darkGray',
                textDecoration: 'underline'
              }}
            >
              Edit
            </Typography>
            <EditOutlinedIcon 
              sx={{
                color: 'primary.mainBlue',
                fontSize: '20px',
                ml: '4px'
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            padding: '16px',
            borderRadius: '8px',
            boxShadow: '0px 2px 10px 0px #5B87EF33',
          }}
        >
          <Box>
            <Typography
              variant="h4"
              color="primary.black"
              sx={{
                pb: '16px',
                borderBottom: '1px solid #ABB7C0',
              }}
            >
              Your Profile
            </Typography>
            <Grid container spacing='16px'>
              <Grid item md={6}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mt: '16px',
                  }}
                >
                  {loadingAuth ? (
                    <Skeleton
                      variant="circular"
                      sx={{
                        width: '80px',
                        minWidth: '80px',
                        height: '80px'
                      }}
                    />
                  ) : (
                    <BaseImage
                      sx={{
                        width: '80px',
                        minWidth: '80px',
                        height: '80px'
                      }}
                      sximage={{
                        borderRadius: '50%',
                        objectFit: 'cover'
                      }}
                      src={auth?.avatarUrl || '//ssl.gstatic.com/accounts/ui/avatar_2x.png'}
                      alt='profile-avatar'
                    />
                  )}
                  {loadingAuth ? (
                    <Stack direction={'column'} spacing={1} width={'100%'} ml='16px'>
                      <Skeleton variant="rounded" width={'100%'} height={30} />
                      <Skeleton variant="rounded" width={'100%'} height={20} />
                    </Stack>
                  ) : (
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        flexGrow: 1,
                        ml: '16px'
                      }}
                    >
                      <Typography variant="h2" color="primary.black">
                        {`${auth?.firstName} ${auth?.lastName}`}
                      </Typography>
                      <Typography variant="body" color='primary.darkGray'>
                        {auth?.email}
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item md={6}>
                {/* <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    padding: '13px 12px 12px',
                  }}
                >
                  <Typography
                    variant="h4"
                    sx={{
                      color: 'primary.darkGray',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    Sex assigned at birth
                  </Typography>
                  <Box
                    sx={{
                      width: '100%',
                      height: '1px',
                      bgcolor: 'primary.lightGray',
                      mx: '16px'
                    }}
                  />
                  <Typography
                    variant="h4"
                    sx={{
                      color: 'primary.black',
                    }}
                  >
                    {auth?.sex}
                  </Typography>
                </Box> */}
                {loadingAuth ? (
                  <Stack direction={'column'} spacing={1} width={'100%'} my='16px'>
                    <Skeleton variant="rounded" width={'100%'} height={30} />
                    <Skeleton variant="rounded" width={'100%'} height={30} />
                    <Skeleton variant="rounded" width={'100%'} height={30} />
                    <Typography
                      variant="subText"
                      color="primary.darkGray"
                    >
                      Bio
                    </Typography>
                    <Skeleton variant="rounded" width={'100%'} height={15} />
                    <Skeleton variant="rounded" width={'100%'} height={15} />
                  </Stack>
                ) : (
                  <>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                      backgroundColor: 'primary.lightGreen',
                      padding: '13px 12px 12px',
                      borderRadius: '5px',
                      mt: '16px'
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'primary.darkGray',
                      }}
                    >
                      NPI Number
                    </Typography>
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'primary.black',
                      }}
                    >
                      {auth?.staffProfile?.npi || 'xxxxxxxxxx'}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                      padding: '13px 12px 12px',
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'primary.darkGray',
                      }}
                    >
                      Title
                    </Typography>
                    <Box
                      sx={{
                        width: '100%',
                        height: '1px',
                        bgcolor: 'primary.lightGray',
                        mx: '16px'
                      }}
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'primary.black',
                      }}
                    >
                      {auth?.staffProfile?.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      width: '100%',
                      padding: '13px 12px 12px',
                    }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'primary.darkGray',
                      }}
                    >
                      Specialty
                    </Typography>
                    <Box
                      sx={{
                        width: '100%',
                        height: '1px',
                        bgcolor: 'primary.lightGray',
                        mx: '16px'
                      }}
                    />
                    <Typography
                      variant="h4"
                      sx={{
                        color: 'primary.black',
                      }}
                    >
                      {auth?.staffProfile?.specialty}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      width: '100%',
                      padding: '13px 12px 12px',
                      display: 'flex',
                      flexDirection: 'column'
                    }}
                  >
                    <Typography
                      variant="subText"
                      color="primary.darkGray"
                    >
                      Bio
                    </Typography>
                    <Typography
                      variant="body"
                      sx={{
                        color: 'black',
                      }}
                    >
                      {auth?.staffProfile?.bio}
                    </Typography>
                  </Box>
                  </>
                )}
              </Grid>
            </Grid>
            <Box
              sx={{
                borderTop: '1px solid',
                borderColor: 'primary.lightBlue',
                pt: '32px'
              }}
            >
              <Grid container spacing={'16px'}>
                <Grid item md={6}>
                  <Typography variant="h4" color='primary.black'>
                    Clinic information
                  </Typography>
                </Grid>
                <Grid item md={6}>
                  <Box
                    sx={{
                      padding: '8px 12px',
                      borderRadius: '5px',
                      display: 'flex',
                      justifyContent: 'space-between',
                      bgcolor: 'primary.darkGray',
                      alignItems: 'center'
                    }}
                  >
                    <Typography variant="h4" color='primary.white'>
                      Clinic Phone
                    </Typography>
                    <Box
                      sx={{
                        border: '1px solid',
                        borderColor: 'primary.lightGray',
                        padding: '10px 16px',
                        borderRadius: '100px',
                        bgcolor: '#FFFFFF26'
                      }}
                    >
                      <Typography variant="body" color='primary.white'>
                        {auth?.staffProfile?.phone || 'XXX-XXX-XXXX'}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mt: '32px'
                    }}
                  >
                    <Typography variant="h3" color="primary.mainBlue">
                      Clinic Address
                    </Typography>
                    <ContentCopyIcon 
                      sx={{
                        color: 'primary.darkGray',
                        cursor: 'pointer'
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      mt: '8px'
                    }}
                  >
                    {loadingAuth ? (
                      <Stack direction={'column'} spacing={1} width={'100%'} my='16px'>
                        <Skeleton variant="rounded" width={'100%'} height={20} />
                        <Skeleton variant="rounded" width={'100%'} height={20} />
                      </Stack>
                    ) : (
                      <Typography variant="body" color="primary.black">
                        {auth?.staffProfile?.clinicAddressLine1} <br />
                        {`${auth?.staffProfile?.clinicAddressCity || ''}, ${auth?.staffProfile?.clinicAddressState || ''}, ${auth?.staffProfile?.clinicAddressPostalCode || ''}`}
                      </Typography>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            {/* Order more kits */}
            {myPermissions.includes(ViewPermissions.ORDER_KIT) &&
              <Box
                sx={{
                  borderTop: '1px solid',
                  borderColor: 'primary.lightBlue',
                  pt: '32px'
                }}
              >
                <Grid container spacing={'16px'}>
                  <Grid item md={6}>
                    <Typography variant="h4" color='primary.black'>
                      Order more kits
                    </Typography>
                  </Grid>
                  <Grid item md={6}>
                    <Typography variant="h3" color="primary.black">
                      How many kits would you like to order?
                    </Typography>
                    <Typography variant="subText" color="primary.black">
                      (Maximum number of kits is 5)
                    </Typography>
                    {/* <BaseInput
                      fullWidth
                      placeholder='Number of kits'
                      sx={{
                        marginTop: '8px'
                      }}
                      onChange={(e) => setNumberOfKits(e.target.value)}
                      value={numberOfKits}
                    /> */}
                    <BaseButton 
                      sx={{
                        width: '100%',
                        marginTop: '8px',
                        borderRadius: '100px',
                      }}
                      buttonType="primary"
                      onClick={handleOrderKit}
                    >
                      Order more kits
                    </BaseButton>
                  </Grid>
                </Grid>
              </Box>
            }
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MyProfile;
